"use client";

import React, { useRef, useEffect } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {globalTransition} from "../../assets/animate/globalAnimation"


const DirectorProfile = () => {
  const controls = useAnimation();
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });
  

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.3,
        ...globalTransition
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        ...globalTransition,
        
        ease: "easeOut",
       
      },
    },
  };

  return (
    <div ref={sectionRef} className="relative w-full">
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="h-1/2 bg-white"></div>
        <div className="h-1/2 bg-[#2D3741]"></div>
      </div>

      <div className="container relative z-10">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={controls}
          className="lg:bg-[#AB052D] bg-primary relative w-full flex flex-col md:flex-row items-center justify-between overflow-hidden"
        >
          <motion.div variants={childVariants} className="absolute top-6 hidden lg:block left-[40%] right-0">
            <h4 className="text-white text-xl font-normal">Director</h4>
            <div className="border-b border-red-600/90 mt-4"></div>
          </motion.div>

          <motion.div variants={childVariants} className="absolute top-6 lg:hidden left-8 right-8">
            <h4 className="text-white text-lg font-normal">Director</h4>
            <div className="border-b border-red-700/50 mt-2"></div>
          </motion.div>

          <div className="flex flex-col md:flex-row items-center pb-10 lg:pb-0 p-4 justify-around w-full pt-20 md:pt-0">
            <motion.div variants={childVariants} className="w-full md:w-2/5 flex justify-center items-center px-4 md:px-8">
              <img src="/assets/image/director.png" alt="Sanjay Jain, Director" className="max-w-full h-auto" />
            </motion.div>

            <motion.div variants={childVariants} className="lg:bg-[#1e2730] bg-[#AB052D] text-white rounded-xl p-14 w-full md:w-1/2 max-w-[500px] md:mr-8">
              <h3 className="text-4xl font-medium mb-2 relative pt-4 before:content-[''] before:absolute before:top-0 before:left-0 before:w-20 before:h-0.5 before:bg-white">
                Sanjay Jain
              </h3>
              <p className="text-sm lg:text-lg opacity-90 mb-1">B.E. Mechanical Engineering</p>
              <p className="text-sm lg:text-lg opacity-90 mb-6">35 years Experience</p>

              <div className="flex mt-6">
                <span className="text-5xl mr-4 -mt-2 font-serif opacity-80">❝</span>
                <p className="lg:text-lg text-sm font-light leading-relaxed">
                 With 35 years of Experience in the hydraulic industry, I understand that 
                 oil cleanliness is the leading factor  in hydraulic system failures.
                 At Siskon Ventures Pvt.LTD, we prioritize advanced filtration and monitoring solutions 
                 to ensure optimal system performance, longevity, and reliability.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DirectorProfile;




// "use client";

// import React, { useEffect } from "react";
// import { Box, Typography, Card, Container, useMediaQuery } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { useTheme } from "@mui/material/styles";
// import { motion, useAnimation } from "framer-motion";

// // Styled components
// const ProfileSection = styled(Box)(({ theme }) => ({
//   backgroundColor: "#3A4855", // Deep red background
//   display: "flex",
//   position: "relative",
//   minHeight: "500px",
//   overflow: "hidden",
//   // marginTop: "400px",

//   [theme.breakpoints.down("md")]: {
//     flexDirection: "column",
//   },
// }));

// const ContentWrapper = styled(Box)(({ theme }) => ({
//   backgroundColor: "#AB052D", // Background color for the extra div
//   width: "80%",
//   display: "flex",
//   justifyContent: "start",
//   padding: theme.spacing(4),
//   borderRadius: "12px",
//   [theme.breakpoints.down("md")]: {
//     width: "100%",
//     padding: theme.spacing(2),
//   },
// }));

// const MotionTypography = motion(Typography);
// const MotionBox = motion(Box);
// const MotionCard = motion(Card);

// const DirectorTitle = styled(MotionTypography)(({ theme }) => ({
//   color: "white",
//   position: "relative",
//   paddingTop: theme.spacing(8),
//   paddingBottom: theme.spacing(1),
//   textAlign: "center",
//   fontSize: "2rem",
//   fontWeight: 400,
//   "&::after": {
//     content: '""',
//     position: "absolute",
//     bottom: 0,
//     left: "50%",
//     transform: "translateX(-50%)",
//     width: "80px",
//     height: "2px",
//     backgroundColor: "rgba(255, 255, 255, 0.5)",
//   },
//   [theme.breakpoints.down("md")]: {
//     paddingTop: theme.spacing(4),
//     fontSize: "1.75rem",
//   },
// }));

// const DirectorImageContainer = styled(MotionBox)(({ theme }) => ({
//   flex: "0 0 40%",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   padding: theme.spacing(4),
//   [theme.breakpoints.down("md")]: {
//     padding: theme.spacing(2),
//   },
// }));

// const DirectorImage = styled("img")({
//   maxWidth: "100%",
//   height: "auto",
// });

// const InfoCard = styled(MotionCard)(({ theme }) => ({
//   backgroundColor: "#1e2730", // Dark blue/gray background
//   color: "white",
//   borderRadius: "12px",
//   padding: theme.spacing(4),
//   maxWidth: "500px",
//   margin: theme.spacing(4),
//   marginLeft: 0,
//   boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
//   [theme.breakpoints.down("md")]: {
//     margin: theme.spacing(2),
//     padding: theme.spacing(3),
//   },
// }));

// const DirectorName = styled(Typography)({
//   fontSize: "2.5rem",
//   fontWeight: 500,
//   marginBottom: "8px",
//   position: "relative",
//   paddingTop: "16px",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "80px",
//     height: "3px",
//     backgroundColor: "white",
//   },
// });

// const DirectorCredentials = styled(Typography)({
//   fontSize: "1.1rem",
//   fontWeight: 300,
//   opacity: 0.9,
//   marginBottom: "4px",
// });

// const DirectorExperience = styled(Typography)({
//   fontSize: "1.1rem",
//   fontWeight: 300,
//   opacity: 0.9,
//   marginBottom: "32px",
// });

// const QuoteContainer = styled(Box)({
//   display: "flex",
//   marginTop: "24px",
// });

// const QuoteIcon = styled(Box)({
//   fontSize: "3rem",
//   lineHeight: 1,
//   marginRight: "16px",
//   marginTop: "-8px",
//   fontFamily: "Georgia, serif",
//   opacity: 0.8,
// });

// const QuoteText = styled(Typography)({
//   fontSize: "1.1rem",
//   fontWeight: 300,
//   lineHeight: 1.6,
// });

// const DirectorProfile: React.FC = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const controls = useAnimation();
//   const cardControls = useAnimation();

//   useEffect(() => {
//     controls.start({ opacity: 1, y: 0, transition: { duration: 0.8 } });
//     cardControls.start({
//       opacity: 1,
//       x: 0,
//       transition: {
//         duration: 0.8,
//         delay: 0.3,
//         ease: "easeOut",
//       },
//     });
//   }, [controls, cardControls]);

//   return (
//     <ProfileSection>
//       <Container
//         maxWidth="xl"
//         sx={{ display: "flex", flexDirection: "column", width: "100%" }}
//       >
//         <ContentWrapper>
//           <DirectorTitle initial={{ opacity: 0, y: -20 }} animate={controls}>
//             Director
//           </DirectorTitle>

//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               alignItems: "center",
//               justifyContent: "space-between",
//               width: "100%",
//             }}
//           >
//             <DirectorImageContainer
//               initial={{ opacity: 0, y: 20 }}
//               animate={controls}
//             >
//               <DirectorImage
//                 src="/assets/image/director.png"
//                 alt="Sanjay Jain, Director"
//               />
//             </DirectorImageContainer>

//             <InfoCard initial={{ opacity: 0, x: 50 }} animate={cardControls}>
//               <DirectorName variant="h2">Sanjay Jain</DirectorName>
//               <DirectorCredentials variant="subtitle1">
//                 B.E. Mechanical Engineering
//               </DirectorCredentials>
//               <DirectorExperience variant="subtitle1">
//                 35 years Experience
//               </DirectorExperience>

//               <QuoteContainer>
//                 <QuoteIcon>❝</QuoteIcon>
//                 <QuoteText>
//                   To be the premier Hydraulic Systems integrator and service
//                   provider, driving industrial evolution through innovative
//                   solutions, precision engineering, and a commitment to
//                   providing unparalleled services worldwide.
//                 </QuoteText>
//               </QuoteContainer>
//             </InfoCard>
//           </Box>
//         </ContentWrapper>
//       </Container>
//     </ProfileSection>
//   );
// };

// export default DirectorProfile;
